<template>
    <div>
    <el-form :model="ruleForm"  ref="ruleForm" label-width="100px">
        <el-form-item label="Tittle" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
        <el-form-item label="Url" prop="url">
            <el-input v-model="ruleForm.url"></el-input>
        </el-form-item>
     </el-form>
    </div>
</template>

<script>
    export default {
        props:{
            ruleForm:{
                type:Object,
                default:function(){}
            }
        },
        data() {
            return {
              
            }
        },
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
}
</style>